<!--  -->
<template>
<div class="downLoad">
    <div class="head">
        <span>点击右上角在浏览器打开 拷贝</span>
    </div>
    <div class="upupoo">
        <img src="../../assets/img/upupoo.png">
    </div>
    <a class="down" :href="downloadUrl">
        <span>下载UPUPOO</span>
    </a>
</div>
</template>

<script>
import { download } from '../../api/index'
export default {
    name: '',
    components: {},
    data() {
        return {
            downloadUrl:'',
        };
    },
    created(){
      this.getDownUrl()
    },
    computed: {},
    methods: {
      getDownUrl(){
        download().then(res=>{
          this.downloadUrl = res.data.qr_code
        })
      },
      download(){
        window.location.href = this.downloadUrl
      }
    },
}
</script>

<style lang="scss" scoped>
.downLoad {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: url('../../assets/img/bg.png') no-repeat;
  background-size: 100% 100%;

  .head {
    position: absolute;
    top: 0.4rem;
    font-size: 0.28rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #a6a6a6;
    left: 2.22rem;
    line-height: 1;
  }

  .upupoo {
    width: 5rem;
    position: absolute;
    top: 2.87rem;
    left: 50%;
    margin-left: -2.5rem;

    img {
      width: 100%;
    }
  }

  .down {
    width: 4rem;
    position: absolute;
    bottom: 2.3rem;
    left: 50%;
    margin-left: -2rem;
    height: 0.96rem;
    background: #3f97ff;
    border-radius: 0.48rem;
    font-size: 0.36rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.96rem;
  }
}
</style>
